/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';


/**
 * Style dependencies
 */
import './styles.scss';

const SyncConnect = ({ resourceConnect }) => {
    
    const [connect, setConnect] = useState(connect);
    const [syncing, setSyncing] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {}, [connect]);

    const syncResource = async (connectId) => {
        cecSdk
            .resource(connectId)
            .sync()
            .then((connect) => {
                console.log(connect);
            });
    };

    return null;
};

export default connect(null, {})(SyncConnect);
